import { inject, Injectable } from '@angular/core';
import { TableColumnBuilder } from '../builders/table-column.builder';
import { TableFilterBuilder } from '../builders/table-filter-builder';
import { ActionButtonBuilder } from '../../action/builders/action-button.builder';
import { TableBuilder } from '../builders/table.builder';
import { TableItemActionBuilderFactory } from './table-item-action-builder.factory';
import { TableCollectionActionBuilderFactory } from './table-collection-action-builder.factory';

@Injectable({
  providedIn: 'root',
})
export class TableBuilderFactory<
  Item,
  Filter = never,
  ItemAction = never,
  CollectionAction = never,
  Action = never,
> {
  private readonly columnsBuilder = inject(TableColumnBuilder<Item, Filter>);
  private readonly filtersBuilder = inject(TableFilterBuilder<Filter>);
  private readonly actionBuilder = inject(ActionButtonBuilder<Action>);
  /* prettier-ignore */
  private readonly collectionActionBuilderFactory = inject(TableCollectionActionBuilderFactory<Item, Filter, CollectionAction>);
  /* prettier-ignore */
  private readonly itemActionBuilderFactory = inject(TableItemActionBuilderFactory);

  public create(): TableBuilder<
    Item,
    Filter,
    ItemAction,
    CollectionAction,
    Action
  > {
    return new TableBuilder(
      this.columnsBuilder,
      this.filtersBuilder,
      this.actionBuilder,
      this.collectionActionBuilderFactory.create(),
      this.itemActionBuilderFactory.create(),
    );
  }
}
